import { compose } from 'recompose';
import { injectIntl } from 'react-intl';

import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import ConfirmUpdateGroupedAppointmentModal from './ConfirmUpdateGroupedAppointmentModal';

export default compose(
  injectIntl,
  withEscHandler,
)(ConfirmUpdateGroupedAppointmentModal);
